<!-- Botón Checkout (redirección) -->
<button
  *ngIf="buttonType === 'checkout'"
  class="pay"
  style="width: 100%;"
  [disabled]="!termsCondictios || loading"
  id="btnCheckout"
  (click)="makePaymentCheckout()">
  <span class="lds-dual-ring" *ngIf="loading"></span>
  <span *ngIf="loading">&nbsp;&nbsp;&nbsp;Please Wait</span>
  <span *ngIf="!loading">Continue to Payment</span>
</button>

<!-- Botón Lightbox -->
<button
  *ngIf="buttonType === 'lightbox'"
  class="pay"
  style="width: 100%;"
  [disabled]="!termsCondictios || loading"
  id="btnLightbox"
  (click)="makePaymentLightbox()">
  <span class="lds-dual-ring" *ngIf="loading"></span>
  <span *ngIf="loading">&nbsp;&nbsp;&nbsp;Please Wait</span>
  <span *ngIf="!loading">Continue to Payment</span>
</button>
